import React from "react";
import "../styles/Coordonates.css";

const Coordonates = () => {
  return (
    <div className="articleCoordonates">
      <h1 className='titleFooter'>Coordonnées :</h1>
      <p>2 Rue du Musée 38200 VIENNE</p>
      <p>06 15 40 05 60</p>
      <p>maitreisabellepivet@gmail.com</p>
    </div>
  );
};

export default Coordonates;
